__webpack_require__.p = "/mg-full/";